import React from 'react';
import { Helmet } from 'react-helmet';
import Aboutus from './Aboutus';

const About = () => (
  <>
    <Helmet>
      <title>About Us | MilaajBrandset</title>
      <meta
        name="description"
        content="Learn more about MilaajBrandset, our values, and our mission to deliver exceptional digital solutions tailored to your business needs."
      />
      <meta
        name="keywords"
        content="MilaajBrandset, about us, company information, digital solutions, business values"
      />
      <meta property="og:title" content="About Us | MilaajBrandset" />
      <meta
        property="og:description"
        content="Learn more about MilaajBrandset, our values, and our mission to deliver exceptional digital solutions tailored to your business needs."
      />
    </Helmet>
    <Aboutus />
  </>
);

export default About;